import { useState } from 'react'

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getEventIcons } from './helpers'
import * as Styles from './styles'

const HistoryEvent = ({ event }) => {
  const theme = useTheme()
  const eventIcons = getEventIcons(theme)
  const [expanded, setExpanded] = useState(false)
  const { icon, title, subtitle, expandable, details, batchId, time, userName } = event

  const handleToggle = () => setExpanded(prev => !prev)

  const renderHeaderContent = () => (
    <>
      {eventIcons[icon]}
      <Styles.TitleContainer>
        <Text type="bodyMRegular">{title}</Text>
        {expandable && (expanded ? <CaretUpIcon size={20} /> : <CaretDownIcon size={20} />)}
      </Styles.TitleContainer>
    </>
  )

  return (
    <Styles.Container>
      {expandable ? (
        <Styles.Header onClick={handleToggle}>{renderHeaderContent()}</Styles.Header>
      ) : (
        <Styles.StaticHeader>{renderHeaderContent()}</Styles.StaticHeader>
      )}
      {subtitle && (
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {subtitle}
        </Text>
      )}
      {expandable && expanded && (
        <Styles.DetailsContainer>
          {details.map((detail, index) => (
            <Styles.DetailItem key={`${batchId}-${index}`}>
              <Text type="bodySRegular" color={theme.colors.text.muted}>
                · {detail.value ? `${detail.label}: ${detail.value}` : detail.label}
              </Text>
            </Styles.DetailItem>
          ))}
        </Styles.DetailsContainer>
      )}
      <Styles.MetaContainer>
        <Text type="bodySRegular" color={theme.colors.text.subtle}>
          {time}
        </Text>
        <Text type="bodySRegular" color={theme.colors.text.subtle}>
          {userName}
        </Text>
      </Styles.MetaContainer>
    </Styles.Container>
  )
}

export default HistoryEvent
